var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useMemo } from "react";
import { AutocompleteInput, useGetList, useNotify, required } from "react-admin";
var SelectTemplate = function (_a) {
    var tenantId = _a.tenantId, templateType = _a.templateType, source = _a.source, label = _a.label, onSelectTemplate = _a.onSelectTemplate, customStyle = _a.customStyle, disabled = _a.disabled, value = _a.value, isRequired = _a.isRequired;
    var notify = useNotify();
    var _b = useGetList("sequent_backend_template", {
        filter: {
            tenant_id: tenantId,
            type: templateType,
        },
        sort: { field: "template.name", order: "ASC" },
        pagination: { page: 1, perPage: 100 },
    }, {
        onError: function (error) {
            return notify((error === null || error === void 0 ? void 0 : error.message) || "ra.notification.http_error", { type: "error" });
        },
    }), templates = _b.data, isLoading = _b.isLoading;
    var handleTemplateChange = function (alias) {
        if (onSelectTemplate) {
            onSelectTemplate({ alias: alias });
        }
    };
    var choices = useMemo(function () {
        // Ensure templates and its nested properties exist
        var items = templates;
        if (!items)
            return [];
        // Create a shallow copy and sort it
        return __spreadArray([], items, true).sort(function (a, b) {
            var _a, _b;
            var left = (_a = a === null || a === void 0 ? void 0 : a.template) === null || _a === void 0 ? void 0 : _a.name;
            var right = (_b = b === null || b === void 0 ? void 0 : b.template) === null || _b === void 0 ? void 0 : _b.name;
            if (!left || !right)
                return 0;
            return left.localeCompare(right);
        })
            .map(function (template) { return ({
            id: template.alias,
            name: template.template.name,
        }); });
        // Dependency array: re-run only when the original items array changes
    }, [templates]);
    return (_jsx(AutocompleteInput, { source: source, label: label, fullWidth: true, choices: choices, onChange: handleTemplateChange, debounce: 100, sx: customStyle, disabled: disabled, validate: isRequired ? [required()] : undefined, isLoading: isLoading, optionValue: "id", optionText: "name", defaultValue: value || "" }));
};
export default SelectTemplate;
